import React, { useCallback } from 'react'
import { I18n, hooks } from '@front/volcanion'
import getExportFilename from '@abra/utils/getExportFilename'

import { TableCell, IconButton, Icon } from '@mui/material'
import { Loader } from '@front/squirtle'
import { TextCell } from '@abra/elements/table/cells/basics/'

import FormatUtils from '@front/squirtle/utils/format'

const Row = ({ row }) => {
  const filename = getExportFilename(_.get(row, 'name'), row.createdAt)
  const download = hooks.useFileDownload('GET', 'task/download', { task_id: _.get(row, 'task_id') }, { filename })
  const [{ name: user_name }] = hooks.useCustomerInfo(row?.user)
  const onClick = useCallback(() => download(), [download])

  return <>
    <TableCell size={'small'}><TextCell value={FormatUtils.formatDateBackToFront(_.get(row, 'createdAt'))} /></TableCell>
    <TableCell size={'small'}><TextCell value={user_name || '-'} /></TableCell>
    <TableCell size={'small'}><TextCell value={row?.user_type ? I18n.t(`export.user_type.${row.user_type}`, { defaultValue: row.user_type }) : '-'} /></TableCell>
    <TableCell size={'small'}><TextCell value={I18n.t(`export.name.${_.get(row, 'name')}`)} /></TableCell>
    <TableCell size={'small'} sx={{ textAlign: 'center' }}>
      <Loader isLoading={!_.includes(['complete', 'failed'], row?.status)} size={24}>
        {row?.status === 'complete' ? (
          <IconButton onClick={onClick}>
            <Icon color='primary'>{'download'}</Icon>
          </IconButton>
        ) : (
          <Icon color='error'>{'error'}</Icon>
        )}
      </Loader>
    </TableCell>
  </>
}

export default React.memo(Row)
